import React from "react";
import { IconWithText } from "./IconWithText";

export function MeetingNotesCompositeIcon(props:{
    notes:string | null | undefined;
}) {

    const hasNotes = props.notes !== null && props.notes !== undefined && props.notes.trim() !== '';

    return (
        <IconWithText icon="note_stack"
            variant={hasNotes ? 'active' : 'passive'}
            tooltipContent={hasNotes ?  "Mødet har et referat" : "Der er ikke oprettet et referat"}
            fontSize="14px">

            {hasNotes ? "" : "Intet referat"}

        </IconWithText>
    );
}